export default __webpack_public_path__ + "static/media/video-card.37b0a2e5.png";